import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getFeatureGates, FEATURE_GATES_CACHE_MS } from '../api/network_calls';
import { set_trial_offer } from '../store/appSlice';
import { useAppDispatch } from '../store/hooks';

export const featureGateKeys = {
  gates: (userId: string) => ['featureGates', userId] as const,
};

export const useFeatureGates = (userId: string, enabled = true) => {
  const dispatch = useAppDispatch();
  const query = useQuery({
    queryKey: featureGateKeys.gates(userId),
    queryFn: () => getFeatureGates(userId),
    enabled: enabled && !!userId,
    staleTime: FEATURE_GATES_CACHE_MS,
    gcTime: FEATURE_GATES_CACHE_MS,
  });

  useEffect(() => {
    if (
      query.data &&
      Object.prototype.hasOwnProperty.call(query.data, 'trialOffer')
    ) {
      dispatch(set_trial_offer(query.data.trialOffer || null));
    }
  }, [dispatch, query.data]);

  return query;
};
